import React from 'react';

import VideoPlayer from './videoPlayer';

import styles from '../styles/videoVersioningVideo.module.scss';

const VideoVersioningVideo = ({ video }) => (
  video && (
    <div className={styles.container}>
      <VideoPlayer
        className={styles.element}
        isReplaceVideoDisabled
        shouldNotAutoplay
        shouldNotEnroll
        shouldNotFloat
        hasBookmark={false}
        video={video}
      />
    </div>
  )
);

export default React.memo(VideoVersioningVideo);
